import { Link } from 'react-router-dom';
import { BillLogo } from '../ui/BillLogo';
import { NotificationBell } from '../notifications/NotificationBell';
import { GlobalOmnibox } from '../omnibox/GlobalOmnibox';
import { AccountMenu } from './AccountMenu';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

/**
 * Phone counterpart of the desktop TopBar: a 56px row of hamburger, logo, bell
 * and account menu, the hamburger opening the sidebar drawer (where Log
 * activity and the timer live). The "Search or ask Bill" field is a 40px row
 * beneath, full width, and opens as a bottom sheet.
 */
export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header className="shrink-0 border-b border-border/70 bg-bg-primary lg:hidden">
      <div className="flex h-14 items-center justify-between px-4">
        <button
          onClick={onMenuClick}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-text-muted hover:bg-bg-muted hover:text-secondary"
          aria-label="Open menu"
        >
          <MenuIcon className="h-6 w-6" />
        </button>

        <Link to="/dashboard" className="text-xl text-primary no-underline">
          <BillLogo />
        </Link>

        <div className="flex items-center gap-2">
          <NotificationBell />
          <AccountMenu />
        </div>
      </div>
      <div className="px-4 pb-3 pt-1">
        <GlobalOmnibox variant="phone" />
      </div>
    </header>
  );
}

function MenuIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );
}
